document.querySelectorAll('.rtp').forEach((section) => {
  if (section.dataset.ready) return;
  section.dataset.ready = 'true';

  const track = section.querySelector('[data-rtp-track]');
  const previous = section.querySelector('[data-rtp-prev]');
  const next = section.querySelector('[data-rtp-next]');
  const originals = track ? [...track.querySelectorAll('.rtp__card')] : [];
  const delay = Math.max(1000, Number(section.dataset.delay || 4000));
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let timer;
  let settleTimer;
  let pointerStart;
  let userStopped = false;
  let resetting = false;

  if (!track || originals.length < 2) return;

  const clone = (card) => {
    const copy = card.cloneNode(true);
    copy.removeAttribute('id');
    copy.removeAttribute('data-shopify-editor-block');
    copy.setAttribute('aria-hidden', 'true');
    copy.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
    return copy;
  };

  // Two guard sets on each side keep the loop seamless even when desktop shows
  // several cards at once. The visitor always remains inside an equivalent
  // central cycle and can never reach a real end of the track.
  for (let set = 0; set < 2; set += 1) {
    originals.slice().reverse().forEach((card) => track.prepend(clone(card)));
    originals.forEach((card) => track.append(clone(card)));
  }

  const centralStart = originals.length * 2;

  const cards = () => [...track.querySelectorAll('.rtp__card')];
  const jumpTo = (index) => {
    const card = cards()[index];
    if (!card) return;
    resetting = true;
    const snap = track.style.scrollSnapType;
    const behavior = track.style.scrollBehavior;
    track.style.scrollSnapType = 'none';
    track.style.scrollBehavior = 'auto';
    track.scrollLeft = card.offsetLeft;
    requestAnimationFrame(() => {
      track.style.scrollSnapType = snap;
      track.style.scrollBehavior = behavior;
      resetting = false;
    });
  };
  const nearestIndex = () => {
    const list = cards();
    return list.reduce((best, card, index) =>
      Math.abs(card.offsetLeft - track.scrollLeft) < Math.abs(list[best].offsetLeft - track.scrollLeft) ? index : best, 0);
  };
  const settle = () => {
    if (resetting) return;
    const index = nearestIndex();
    if (index < originals.length) jumpTo(index + originals.length * 2);
    else if (index >= originals.length * 4) jumpTo(index - originals.length * 2);
  };
  const move = (direction) => {
    const list = cards();
    const target = Math.max(0, Math.min(list.length - 1, nearestIndex() + direction));
    track.scrollTo({ left: list[target].offsetLeft, behavior: reducedMotion ? 'auto' : 'smooth' });
  };
  const pause = () => clearInterval(timer);
  const start = () => {
    pause();
    if (!userStopped && section.dataset.autoplay === 'true' && !reducedMotion) timer = setInterval(() => move(1), delay);
  };
  const stopForUser = () => {
    userStopped = true;
    pause();
  };

  previous?.addEventListener('click', () => { stopForUser(); move(-1); });
  next?.addEventListener('click', () => { stopForUser(); move(1); });
  track.addEventListener('scroll', () => {
    clearTimeout(settleTimer);
    settleTimer = setTimeout(settle, 90);
  }, { passive: true });
  track.addEventListener('scrollend', settle, { passive: true });
  track.addEventListener('pointerdown', (event) => { pointerStart = { x: event.clientX, y: event.clientY }; }, { passive: true });
  track.addEventListener('pointerup', (event) => {
    if (!pointerStart) return;
    const dx = Math.abs(event.clientX - pointerStart.x);
    const dy = Math.abs(event.clientY - pointerStart.y);
    pointerStart = null;
    if (dx > 10 && dx > dy) stopForUser();
  }, { passive: true });
  track.addEventListener('pointercancel', () => { pointerStart = null; }, { passive: true });
  track.addEventListener('wheel', (event) => {
    if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) stopForUser();
  }, { passive: true });
  section.addEventListener('mouseenter', pause);
  section.addEventListener('mouseleave', start);
  addEventListener('resize', () => {
    const logicalIndex = ((nearestIndex() - centralStart) % originals.length + originals.length) % originals.length;
    jumpTo(centralStart + logicalIndex);
  }, { passive: true });

  requestAnimationFrame(() => { jumpTo(centralStart); start(); });
});
